import { Button, Grid, Typography } from "@material-ui/core";
import React from "react";
import "./Aboutme.css";
import BorderColorIcon from "@material-ui/icons/BorderColor";
import Typewriter from "typewriter-effect";
import Typical from "react-typical";
import { useHistory } from "react-router-dom";

function Aboutme() {
  const history = useHistory();

  return (
    <div className="about">
      <div>
        <h2 className="title">
          <Typical
            style={{ textDecoration: "underline" }}
            loop={Infinity}
            wrapper="b"
            steps={["About me", 3000]}
          ></Typical>
        </h2>
        <div className="max-width">
          <div className="about-content">
            <Grid container spacing={2}>
              <Grid item xs={12} md={6} lg={6}>
                <div className="left">
                  <img
                    src="./image/programming2.jpg"
                    alt="profile"
                    style={{ height: "250px", width: "400px" }}
                  />
                </div>
              </Grid>
              <Grid item xs={12} md={6} lg={6}>
                <div className="right">
                  <p>
                    Full stack web and mobile developer with background
                    knowledge of
                  </p>
                  <p>
                    MERN stacks with redux, along with a knack of building
                    applications
                  </p>
                  <p>
                    with utmost efficiency. Strong professional with a BSC
                    willing to be an asset for an organization.
                  </p>

                  <Typography className="text">
                    <BorderColorIcon />
                    &nbsp;&nbsp; Full stack web development
                  </Typography>
                  <Typography className="text">
                    <BorderColorIcon />
                    &nbsp;&nbsp; Interactive front end as per the design
                  </Typography>
                  <Typography className="text">
                    {" "}
                    <BorderColorIcon />
                    &nbsp;&nbsp; ReactJS
                  </Typography>
                  <Typography className="text">
                    <BorderColorIcon />
                    &nbsp;&nbsp; Redux for state Management
                  </Typography>
                  <Typography className="text">
                    <BorderColorIcon />
                    &nbsp;&nbsp; Building REST API
                  </Typography>
                  <Typography className="text">
                    <BorderColorIcon />
                    &nbsp;&nbsp; Managing database
                  </Typography>
                  <div className="button">
                    {/* <Button variant="contained" color="primary">
                      Hire me
                    </Button> */}
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={() => history.push("/cvpdf")}
                    >
                      View my CV
                    </Button>
                  </div>
                </div>
              </Grid>
            </Grid>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Aboutme;
